import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const getFavorites = async () => {
  const res = await axios.get(`${API_URL}/favorites`, { withCredentials: true });
  return res.data;
};

export const toggleFavorite = async (listingId) => {
  const res = await axios.post(`${API_URL}/favorites/${listingId}`, {}, { withCredentials: true });
  return res.data;
};

export const removeFavorite = async (listingId) => {
  const res = await axios.delete(`${API_URL}/favorites/${listingId}`, { withCredentials: true });
  return res.data;
};
